import { isEmpty } from 'lodash'
import { useSelector } from 'react-redux'

import { getVenueSettings } from 'store/Settings/selectors'
import { getRevenueCenters } from 'store/RevenueCenters/selector'
import { venueSettingsUtils } from 'components/VenueSettings/utils'

const RevenueCentersOverrideList = () => {
  const venueSettings = useSelector(getVenueSettings)
  const revenueCenters = useSelector(getRevenueCenters)

  const overridingRevenueCenters =
    venueSettingsUtils.getOverridingRevenueCenters(
      venueSettings,
      revenueCenters
    )

  if (isEmpty(overridingRevenueCenters)) {
    return null
  }

  return (
    <section className="padding-top-base">
      <div className="content-wrapper -block">
        <span className="description -color-danger">
          The following Revenue Centers have Tip Configurations set,
          overriding this venue-level setting:
        </span>
        <ul className="description -color-danger margin-top-xxs">
          {overridingRevenueCenters?.map(({ name, uuid }) => (
            <li key={uuid}>{name}</li>
          ))}
        </ul>
      </div>
    </section>
  )
}

export default RevenueCentersOverrideList
